<template>
  <div class="chart-container">
    <h5 v-if="title" class="chart-title">{{ title }}</h5>
    <div v-if="loading" class="d-flex justify-content-center align-items-center h-100">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
    </div>
    <div v-else-if="!hasData" class="d-flex justify-content-center align-items-center h-100">
      <div class="text-muted">Aucune donnée disponible</div>
    </div>
    <Bar
      v-else
      :chart-data="chartData"
      :chart-options="mergedOptions"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale)

export default {
  name: 'TopDriversBarChart',
  components: { Bar },
  props: {
    title: {
      type: String,
      default: 'Top Chauffeurs'
    },
    drivers: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: 'coursesCount'
    },
    labelKey: {
      type: String,
      default: 'nomChauffeur'
    },
    loading: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 10
    },
    customOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasData() {
      return this.drivers && this.drivers.length > 0;
    },
    sortedDrivers() {
      if (!this.hasData) return [];
      
      return [...this.drivers]
        .sort((a, b) => b[this.valueKey] - a[this.valueKey])
        .slice(0, this.limit);
    },
    chartData() {
      const labels = this.sortedDrivers.map(driver => driver[this.labelKey]);
      const data = this.sortedDrivers.map(driver => driver[this.valueKey]);
      
      return {
        labels,
        datasets: [
          {
            label: 'Courses',
            data,
            backgroundColor: '#36b9cc',
            borderColor: '#36b9cc',
            borderWidth: 1
          }
        ]
      };
    },
    defaultOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            ticks: {
              font: {
                size: 11
              }
            }
          }
        }
      };
    },
    mergedOptions() {
      return {
        ...this.defaultOptions,
        ...this.customOptions
      };
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.chart-title {
  font-size: 1.1rem;
  margin-bottom: 15px;
}
</style>
